<template>
	<BasketCard
			:basket="basket"
			:next-step="store.nextStep"
	/>

	<BlockingOverlay :open="store.loading" />
</template>

<script setup lang="ts">
	import {useStore} from '@/store';
	import {storeToRefs} from 'pinia';
	import BasketCard from '@/components/basket/BasketCard.vue';
	import BlockingOverlay from '@/components/BlockingOverlay.vue';

	const store = useStore();

	const {basket} = storeToRefs(store);
</script>
